const resource = {
  "main": {
    "slogan": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AIカスタマイズでフィットネス革新を体験してください。"])},
    "tagline": {
      "line1": {
        "before": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["すべてのワークアウトと食事を支える、あなたの"])},
        "highlight": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AI"])},
        "middle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["コーチ。"])},
        "highlight2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "after": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      },
      "line2": {
        "before": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "highlight": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "middle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "highlight2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "after": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      },
      "line3": {
        "before": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "highlight": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "middle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "highlight2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "after": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      },
      "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ルーティンを作成してワークアウトを記録。\n次に何を鍛えるべきかを確認できます。\n食事を入力して管理すれば、\nAIが栄養バランスまで評価します。"])}
    },
    "previewImageAlt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["運動・食事・AIコーチ機能を表示するアプリのホーム画面"])},
    "signalLabels": {
      "aiPersonalizedRoutines": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AIカスタムルーティン"])},
      "nextWorkoutGuidance": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["次のワークアウトガイド"])},
      "aiMealEvaluation": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AI食事評価"])}
    }
  },
  "home": {
    "valueProps": {
      "eyebrow": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AIコーチを選ぶ理由"])},
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["記録を、次のより良いトレーニングへ"])},
      "items": {
        "routine": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AIカスタムルーティン"])},
          "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["目標とトレーニングレベルに合わせて、実践しやすいルーティンを作成します。"])}
        },
        "insights": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["記録に基づく分析"])},
          "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["運動・食事・体重の記録をつなぎ、変化の流れを示します。"])}
        },
        "next": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["次のアクションを提案"])},
          "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["あなたの記録をもとに、次回調整すべきポイントを伝えます。"])}
        }
      }
    },
    "mealManagement": {
      "eyebrow": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["食事管理"])},
      "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["今日の栄養状態を\nひと目で確認"])},
      "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["食事ごとのカロリーと栄養バランスをまとめて管理できます。\n\n- 1日の目標と摂取量を比較\n- 炭水化物・たんぱく質・脂質を確認\n- 記録済みの食事をひと目で把握"])},
      "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["詳しく見る"])},
      "imageAlt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["食事管理アプリの画面"])}
    },
    "mealInput": {
      "eyebrow": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AI食事分析"])},
      "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["食事を記録すれば\nAIがすぐに分析"])},
      "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["写真やテキストを追加すると、栄養情報をわかりやすく整理します。\n\n- 数秒で食事を記録\n- カロリーと栄養素を自動計算\n- 食事ごとのAI評価を確認"])},
      "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["詳しく見る"])},
      "imageAlt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["写真やテキストで食事を入力し、AI評価を確認するアプリ画面"])}
    },
    "about": {
      "eyebrow": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["スマートルーティン"])},
      "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["トレーニングルーティンを\nテンプレートで管理"])},
      "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["自分のトレーニングに合うテンプレートを作成し、繰り返し使えます。\n\n- 部位ごとに種目を整理\n- よく使うルーティンをすぐ開始\n- 毎回設定し直さずにトレーニング"])},
      "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["詳しく見る"])},
      "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ルーティンインサイトを見る"])},
      "imageAlt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["トレーニングルーティンのテンプレートを表示するアプリ画面"])}
    },
    "nutrition": {
      "eyebrow": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["進捗インサイト"])},
      "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["身体とトレーニングの変化を\nひと目で確認"])},
      "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["体組成とトレーニングの継続状況を1つの画面で確認できます。\n\n- 体重・筋肉量・体脂肪を追跡\n- 最近のトレーニング状況を確認\n- 注意すべき変化を把握"])},
      "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["詳しく見る"])},
      "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["進捗インサイトを見る"])},
      "imageAlt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["身体データと最近のトレーニング状況を表示するアプリ画面"])}
    },
    "weight": {
      "eyebrow": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ワークアウトレビュー"])},
      "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["トレーニング後すぐに\nAIがレビュー"])},
      "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AIが今回のセッションを最近のトレーニングと比較します。\n\n- セット・回数・重量・ボリュームを確認\n- よかった点を整理\n- 次回の調整ポイントを提案"])},
      "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["詳しく見る"])},
      "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ワークアウトレビューを見る"])},
      "imageAlt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["完了したトレーニングのAI評価を表示するアプリ画面"])},
      "reviewCard": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["今日のAIレビュー"])},
        "metric": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["+8%"])},
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["トレーニング量が増えました"])},
        "body": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["次回は現在の重量を維持し、反復回数を1回増やしてみましょう。"])}
      }
    },
    "aboutPro": {
      "eyebrow": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["長期分析"])},
      "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["トレーニング履歴を\nわかりやすく要約"])},
      "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AIが複数のセッションをつなぎ、全体のトレーニング傾向を示します。\n\n- ワークアウトごとのボリュームを比較\n- 長期的な変化を確認\n- 成長した点と課題を把握"])},
      "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["詳しく見る"])},
      "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["進捗インサイトを見る"])},
      "imageAlt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["トレーニング履歴のAI要約を表示するアプリ画面"])}
    },
    "formulas": {
      "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AIがすべての運動を評価します"])},
      "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["記録された運動をAIが分析し、現在の状態と改善ポイントを伝えます。\n\n- 種目を自動認識\n- 回数・重量・ボリュームを分析\n- 直近の記録に基づくフィードバック\n\n単発ではなく流れで見ます。"])},
      "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["詳しく見る"])},
      "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["フィードバックを見る"])}
    },
    "weightManagement": {
      "eyebrow": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["体重管理"])},
      "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["体重を記録して\n変化を確認"])},
      "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["体重の変化をトレーニング記録と比較し、進捗に応じたAIチェックを確認できます。"])},
      "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["詳しく見る"])},
      "imageAlt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["体重推移とAIチェックを表示する体重管理アプリ画面"])}
    },
    "downloadCta": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["あなたの記録で、トレーニングをもっとスマートに"])},
      "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["運動・食事・体重の記録をひとつにまとめ、記録したデータに基づくAIのフィードバックを受け取りましょう。"])}
    }
  },
  "navigation": {
    "navbar": {
      "appTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AI筋トレ"])},
      "languages": {
        "en": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["英語"])},
        "de": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ドイツ語"])},
        "es": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["スペイン語"])},
        "fr": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["フランス語"])},
        "pt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ポルトガル語"])},
        "zh-TW": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["繁体字中国語"])},
        "it": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["イタリア語"])},
        "id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["インドネシア語"])},
        "th": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["タイ語"])},
        "ar": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["アラビア語"])},
        "kr": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["韓国語"])},
        "jp": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["日本語"])}
      },
      "subpages": {
        "learnMore": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["詳しく見る"])},
        "appStore": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["App Store"])},
        "googlePlay": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Google Play"])},
        "formulas": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Formulas"])},
        "books": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Books"])},
        "articles": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Articles"])},
        "statistics": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Statistics"])},
        "info": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informations"])},
        "donate": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Donate"])}
      }
    },
    "footer": {
      "copyrights": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["All photos and logos used are copyright-free and made available under the MIT or CC license. It is allowed to use, copy, modify or distribute the original or modified content on this website without restriction, provided that the authorship is acknowledged and the source information is posted."])}
    }
  },
  "sciences": {
    "groups": {
      "all": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["All"])},
      "natural": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Natural"])},
      "social": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Social"])},
      "humanities": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Humanities"])},
      "technical": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Technical"])},
      "artistic": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Artistic"])},
      "others": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Others"])}
    },
    "sciences": {
      "philology_iberian": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Iberian Philology"])},
      "philology_english": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["English Philology"])},
      "philology_france": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["French and Benelux Philology"])},
      "philology_italian": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Italian Philology"])},
      "philology_german": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["German Philology"])},
      "philology_poland": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Polish, Ukrainian and Lithuanian Philology"])},
      "philology_baltic": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Baltic Philology"])},
      "philology_nordic": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nordic Philology"])},
      "philology_russian": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Russian Philology"])},
      "philology_carpathian": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Carpathian Philology"])},
      "philology_romanian": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Romanian nad Bulgarian Philology"])},
      "philology_balkan": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["West-Balkan Philology"])},
      "philology_greek": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Greek Philology"])},
      "philology_turkish": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Turkish Philology"])},
      "philology_middleeast": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Middle East, Arabic and Persian Philology"])},
      "philology_indian": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Indian Philology"])},
      "philology_chinese": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chinese Philology"])},
      "philology_korean": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Korean Philology"])},
      "philology_japanese": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Japanese Philology"])},
      "anthropology": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Anthropology"])},
      "philosophy": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Philosophy"])},
      "history": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["History"])},
      "historyofart": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["History of Art"])},
      "culturalstudies": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cultural Studies"])},
      "politology": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Politology"])},
      "law": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Law"])},
      "psychology": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Psychology"])},
      "theology": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Theology"])},
      "defensestudies": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Defense Studies"])},
      "sociology": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sociology"])},
      "internationalstudies": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["International Studies"])},
      "economics": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Economics"])},
      "finances": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Finances"])},
      "accountancy": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Accountancy"])},
      "econometrics": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Econometrics"])},
      "governance": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Governance"])},
      "management": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Management"])},
      "astronomy": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Astronomy"])},
      "bioinformatics": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bioinformatics"])},
      "biochemistry": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Biochemistry"])},
      "biophysics": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Biophysics"])},
      "biotechnology": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Biotechnology"])},
      "biology": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Biology"])},
      "chemistry": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chemistry"])},
      "physics": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Physics"])},
      "geography": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geography"])},
      "geology": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geology"])},
      "informatics": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informatics"])},
      "math": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mathematics"])},
      "ecology": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ecology"])},
      "architecture": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Architecture"])},
      "robotics": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Robotics"])},
      "building_eng": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Building Engeenering"])},
      "energetics": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Energetics"])},
      "electronics": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Electronics"])},
      "quantum_eng": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Quantum Engeenering"])},
      "cosmonautics": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cosmonautics"])},
      "mechanics": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mechanics"])},
      "mechatronics": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mechatronics"])},
      "transport": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Transport"])}
    },
    "branches": {
      "physics": {
        "kinematics": {
          "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kinematics"])},
          "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["We study the motion of bodies, including their acceleration, path and speed"])},
          "subjects": {
            "linear-motion": {
              "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Linear Motion"])},
              "formulas": {
                "velocity-basic": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Average speed"])},
                "velocity-deriv": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Instantaneous speed"])},
                "acceleration-basic": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Average acceleration"])},
                "acceleration-deriv": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Instantaneous acceleration"])},
                "motion-eq-a": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Equations of motion cz. 1"])},
                "motion-eq-b": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Equations of motion cz. 2"])},
                "motion-eq-c": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Equations of motion cz. 3"])},
                "motion-eq-d": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Equations of motion cz. 4"])}
              }
            }
          }
        },
        "dynamics": {
          "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dynamika"])},
          "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zajmiemy się opisem sił działających na różne ciała, a także ich skutkami"])}
        },
        "energy": {
          "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Energia"])},
          "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Praca moc i energia to wielkości, które pozwolą nam spojrzeć na mechanikę z innej strony, a także będą wstępem do kolejnych działów fizyki."])}
        }
      },
      "electronics": {
        "current": {
          "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prąd elektryczny"])},
          "desc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zaczynamy od podstaw, czyli czym jest prąd elektryczny"])}
        }
      }
    },
    "units": {
      "velocity": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prędkość"])},
      "distance": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Droga"])},
      "time": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Czas"])},
      "acceleration": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Przyspieszenie"])}
    }
  },
  "pages": {
    "home": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Strona główna"])},
    "formulas": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tablice"])},
    "articles": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Artykuły"])},
    "books": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Podręczniki"])},
    "statistics": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Statystyki"])},
    "info": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informacje"])},
    "donate": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wesprzyj"])}
  },
  "formulas": {
    "index": {
      "hero": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wzory i tablice naukowe"])}
    },
    "pick": {
      "science": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wybierz jedną z kategorii"])},
      "branch": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wybierz dziedzinę nauki, która cię interesuje"])}
    }
  },
  "errors": {
    "404": {
      "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nasz system nie znalazł takiej strony :c"])},
      "duck": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Więc łap chociaż na pocieszenie kaczkę"])},
      "yeah": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tak, to ten sławny bląd 404"])},
      "song": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bit, bit i pusta kartka, drukarka wydaje szmery Nie ma mnie, bo to nocnego marka nocna warta Świeci się tarcza zegarka - 4:04 Nic nie psuje atmosfery, dźwięki smarta czy wiertarka"])}
    }
  },
  "info": {
    "sure": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ale czy aby na pewno?"])},
    "sections": {
      "begginings": {
        "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Początki"])}
      },
      "activity": {
        "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Działalność"])}
      },
      "goalsandplans": {
        "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cel i plany"])}
      },
      "software": {
        "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Oprogramowanie"])},
        "langscategories": {
          "front-end": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Front-End"])},
          "back-end": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Back-End"])},
          "mobile": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mobilne"])},
          "databases": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bazy danych"])},
          "others": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inne"])}
        }
      },
      "sponsors": {
        "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sponsorzy"])}
      },
      "authors": {
        "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autorzy"])}
      },
      "thanks": {
        "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Podziękowania"])}
      },
      "donate": {
        "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wesprzyj"])}
      },
      "join": {
        "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dołącz"])}
      },
      "contact": {
        "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kontakt"])}
      }
    }
  }
}
export default resource